<template>
  <div class="simple-tab-group" v-show="tabIndex != 1 && tabIndex != 3 && tabIndex != 6 && tabIndex != 9">
    <md-card-content>
      <div class="table-header-info">
        <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
        <div>
          <select v-model="pagination.perPage" name="pages" @change="perPageChange">
            <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>

      <grid ref="SchaDonorTabGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @response="response"
      ></grid>

    </md-card-content>
  </div>
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

import tabColumns from "@/pages/Scholarship/Components/gridOptions/DonatorManagementGrid";

export default {
  name: "SchaDonorTabListComp",

  props: {
    tabIndex : {
      type: Number,
      default : 1
    }
  },

  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      memberNo : null,
      gridProps: {},
      pagination: {
        perPage: 200,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
    };
  },
  methods: {
    sendQuery (index, memberNo){
      this.$refs.SchaDonorTabGrid.invoke("refreshLayout");
      if(!index){ // 목록 재 검색 등 초기화 해야 하는 경우
        this.$refs.SchaDonorTabGrid.invoke("clear");
        this.pagination.total = 0;
        return;
      }
      if(memberNo && memberNo!=this.memberNo){
        this.memberNo = memberNo;
      }
      this.$refs.SchaDonorTabGrid.invoke("readData", 1, {memberNo:this.memberNo});
      this.$refs.SchaDonorTabGrid.invoke("setColumns", tabColumns['tab'+index]);
      this.$refs.SchaDonorTabGrid.invoke("refreshLayout");
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_SCHA_DONOR_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.SchaDonorTabGrid;
      this.gridProps['columns']= tabColumns.tab1;
      this.gridProps['options'].bodyHeight = 300;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.SchaDonorTabGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.SchaDonorTabGrid.invoke("refreshLayout");
    }
  }
};
</script>

<style lang="css" scoped>
</style>